export class banco {
    codigo : number;
    nombre : string;
    activado:boolean;
}


